import ErrorBoundary from "@/ErrorBoundary";
import { useState } from "react";

const defaultStreamerMode = {
    enabled: false,
    shortcut: null,
    details: {
        hidePersonalInfo: true,
        hideInviteLinks: true,
        hideLastMessagesOnDMs: true,
    }
};

export default function StreamerMode() {
    const [streamerMode, setStreamerMode] = useState(() => {
        const storedMode = localStorage.getItem("streamerMode");
        if (!storedMode) {
            localStorage.setItem("streamerMode", JSON.stringify(defaultStreamerMode));
        }
        return storedMode?.startsWith("{") ? JSON.parse(storedMode) : defaultStreamerMode;
    });

    const details = [
        {
            name: "hideInviteLinks",
            label: "Hide Invite Links",
            description: "Hide invite links from your messages"
        },
        {
            name: "hideLastMessagesOnDMs",
            label: "Hide Last Messages on DMs",
            description: "Hide the last messages on your DMs"
        }
    ];

    const changeStreamerMode = () => {
        setStreamerMode({ ...streamerMode, enabled: !streamerMode.enabled });
        localStorage.setItem("streamerMode", JSON.stringify({ ...streamerMode, enabled: !streamerMode.enabled }));
        window.dispatchEvent(new Event('storage'))
    };

    const changeStreamerModeDetails = (name: string) => {
        setStreamerMode({
            ...streamerMode,
            details: {
                ...streamerMode.details,
                [name]: !streamerMode.details?.[name] || false
            }
        });
        localStorage.setItem("streamerMode", JSON.stringify({
            ...streamerMode,
            details: {
                ...streamerMode.details,
                [name]: !streamerMode.details?.[name] || false
            }
        }));
        window.dispatchEvent(new Event('storage'))
    };

    return (
        <div className="mt-4 p-4 bg-brand-dark rounded-lg shadow-lg">
            <ErrorBoundary>
                <h3 className="text-lg text-gray-200 font-semibold">Streamer Mode</h3>
                <p className="text-sm text-gray-400">Protect your privacy while streaming.</p>
                <div className="flex justify-between items-center mt-4">
                    <span className="text-sm text-gray-200">Enable Streamer Mode</span>
                    <div className="relative inline-flex items-center cursor-pointer" onClick={changeStreamerMode}>
                        <input
                            type="checkbox"
                            className="sr-only"
                            checked={streamerMode.enabled}
                        />
                        <div
                            className={`block w-14 h-8 rounded-full transition-colors duration-300 ${streamerMode.enabled ? 'bg-brand-green' : 'bg-brand-profile'}`}
                        >
                            <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform duration-300 ${streamerMode.enabled ? 'translate-x-6' : 'translate-x-0'}`} />
                        </div>
                    </div>
                </div>

                <div className="mt-6">
                    <hr className="border-gray-600 w-full my-4" />
                    <h3 className="text-lg text-gray-200 font-semibold">Streamer Mode Settings</h3>

                    {details.map((detail, index) => (
                        <div key={index} className="flex justify-between items-center mt-4">
                            <ErrorBoundary>
                                <div className="flex flex-col">
                                    <span className="text-sm font-bold text-gray-200">{detail.label}</span>
                                    <span className="text-xs text-gray-400">{detail.description}</span>
                                </div>
                                <div className="relative inline-flex items-center cursor-pointer" onClick={() => changeStreamerModeDetails(detail.name)}>
                                    <input
                                        type="checkbox"
                                        className="sr-only"
                                        checked={streamerMode.details?.[detail.name]}
                                    />
                                    <div
                                        className={`block w-14 h-8 rounded-full transition-colors duration-300 ${streamerMode.details?.[detail.name] ? 'bg-brand-green' : 'bg-brand-profile'}`}
                                    >
                                        <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform duration-300 ${streamerMode.details?.[detail.name] ? 'translate-x-6' : 'translate-x-0'}`} />
                                    </div>
                                </div>
                            </ErrorBoundary>
                        </div>
                    ))}
                </div>
            </ErrorBoundary>
        </div>
    );
}
